import { createContext, useContext } from 'react';
import darkArdTheme from '../../Themes/darkArdTheme';
export const ThemeContext = createContext(darkArdTheme);
export function useTheme() {
    return useContext(ThemeContext);
}
